// eslint-disable-next-line import/named
import styled, { CSSObject } from "@emotion/styled";
import { useTheme, ITheme } from "../../../other/theme";

export type Icon = (props: IProps) => JSX.Element;

interface IProps {
    size?: number;
    color?: string;
    opacity?: number;
}

interface ISetup {
    svg: (svgProps: React.SVGProps<SVGSVGElement>) => React.JSX.Element;
    defaultColor?: (theme: ITheme) => string | undefined;
    css?: CSSObject;
    colorize?: (color: string) => CSSObject;
    opacitize?: (opacity: number) => CSSObject;
}

export const IconBuilder = (setup: ISetup): Icon => {
    const colorize =
        setup.colorize ??
        ((color): CSSObject => ({ "& path": { fill: color } }));

    const opacitize =
        setup.opacitize ??
        ((opacity): CSSObject => ({ "& path": { opacity } }));

    const StyledIcon = styled(setup.svg, {
        shouldForwardProp: () => false
    })<IProps>(props => [
        {
            position: "absolute",
            width: "100%",
            height: "100%"
        },
        setup.css,
        props.color !== undefined ? colorize(props.color) : undefined,
        props.opacity !== undefined ? opacitize(props.opacity) : undefined
    ]);

    const icon = (props: IProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const theme = useTheme();
        const color =
            props.color ?? setup.defaultColor?.(theme) ?? theme.foreground;
        return (
            <Container {...props} color={color}>
                <StyledIcon {...props} color={color} />
            </Container>
        );
    };
    return icon;
};

const Container = styled("div")<IProps>(props => ({
    position: "relative",
    textAlign: "left",
    width: "100%",
    height: "100%",
    ...(props.size !== undefined
        ? { display: "inline-block", width: props.size, height: props.size }
        : undefined)
}));
